import { render, staticRenderFns } from "./step-contacts.vue?vue&type=template&id=5554dd72"
import script from "./step-contacts.vue?vue&type=script&lang=ts"
export * from "./step-contacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports